<template>
  <div class="interview-card item-card">
    <content-line>
      <template #text>
        <v-chip
          v-if="interviewLocationBadge"
          :color="interviewLocationBadge.color"
          text-color="light"
          class="pa-2 mr-3"
          small
          >{{ interviewLocationBadge.shortcut }}</v-chip
        >
        <span>{{ interview.time }}</span>
      </template>
    </content-line>

    <div class="item-card__content">
      <v-layout class="item-card__group mb-2">
        <v-icon color="appMain">person</v-icon>
        <span>{{ interview.name }}</span>
      </v-layout>

      <v-layout class="item-card__group mb-3">
        <v-icon color="appMain">info</v-icon>
        <span>{{ interview.interviewId }}</span>
        <v-chip v-if="scheduled" color="primary" small class="ml-2"
          >Scheduled</v-chip
        >
      </v-layout>

      <v-btn
        block
        color="appMain"
        class="light--text"
        :disabled="disabled"
        @click.stop="$emit('addToInterview')"
      >
        Add to interview
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VectorInterviewCard',
  props: {
    interview: {
      type: Object,
      default: () => ({}),
    },
    scheduled: Boolean,
    disabled: Boolean,
  },
  computed: {
    interviewLocationBadge() {
      const { interviewLocation } = this.interview;
      if (!interviewLocation) return null;

      const shortcut = (interviewLocation || '').substring(0, 1).toLowerCase();
      const badgeColors = {
        a: 'appMain',
        c: 'primary',
        r: 'warning',
      };

      return {
        shortcut,
        color: badgeColors[shortcut] || 'appMain',
      };
    },
  },
};
</script>

<style lang="less">
.interview-card {
  .content-line {
    .v-chip {
      text-transform: capitalize;
    }
  }
  .content-line__text {
    display: flex;
    align-items: center;
  }
}

.interview-card.selected {
  overflow: hidden;
  .content-line {
    margin: -3px -3px 0;
  }

  .item-card__content {
    margin: 0 -3px -3px;
  }
}
</style>
